import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Disposable } from '../../../base/common/lifecycle.js';
export var ViewEventHandler = /*#__PURE__*/function (_Disposable) {
  _inherits(ViewEventHandler, _Disposable);

  var _super = _createSuper(ViewEventHandler);

  function ViewEventHandler() {
    var _this;

    _classCallCheck(this, ViewEventHandler);

    _this = _super.call(this);
    _this._shouldRender = true;
    return _this;
  }

  _createClass(ViewEventHandler, [{
    key: "shouldRender",
    value: function shouldRender() {
      return this._shouldRender;
    }
  }, {
    key: "forceShouldRender",
    value: function forceShouldRender() {
      this._shouldRender = true;
    }
  }, {
    key: "setShouldRender",
    value: function setShouldRender() {
      this._shouldRender = true;
    }
  }, {
    key: "onDidRender",
    value: function onDidRender() {
      this._shouldRender = false;
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      return false;
    }
  }, {
    key: "onCursorStateChanged",
    value: function onCursorStateChanged(e) {
      return false;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      return false;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return false;
    }
  }, {
    key: "onFocusChanged",
    value: function onFocusChanged(e) {
      return false;
    }
  }, {
    key: "onLanguageConfigurationChanged",
    value: function onLanguageConfigurationChanged(e) {
      return false;
    }
  }, {
    key: "onLineMappingChanged",
    value: function onLineMappingChanged(e) {
      return false;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return false;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return false;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return false;
    }
  }, {
    key: "onRevealRangeRequest",
    value: function onRevealRangeRequest(e) {
      return false;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return false;
    }
  }, {
    key: "onThemeChanged",
    value: function onThemeChanged(e) {
      return false;
    }
  }, {
    key: "onTokensChanged",
    value: function onTokensChanged(e) {
      return false;
    }
  }, {
    key: "onTokensColorsChanged",
    value: function onTokensColorsChanged(e) {
      return false;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return false;
    } // --- end event handlers

  }, {
    key: "handleEvents",
    value: function handleEvents(events) {
      var shouldRender = false;

      for (var i = 0, len = events.length; i < len; i++) {
        var e = events[i];

        switch (e.type) {
          case 0
          /* ViewConfigurationChanged */
          :
            if (this.onConfigurationChanged(e)) {
              shouldRender = true;
            }

            break;

          case 1
          /* ViewCursorStateChanged */
          :
            if (this.onCursorStateChanged(e)) {
              shouldRender = true;
            }

            break;

          case 2
          /* ViewDecorationsChanged */
          :
            if (this.onDecorationsChanged(e)) {
              shouldRender = true;
            }

            break;

          case 3
          /* ViewFlushed */
          :
            if (this.onFlushed(e)) {
              shouldRender = true;
            }

            break;

          case 4
          /* ViewFocusChanged */
          :
            if (this.onFocusChanged(e)) {
              shouldRender = true;
            }

            break;

          case 5
          /* ViewLanguageConfigurationChanged */
          :
            if (this.onLanguageConfigurationChanged(e)) {
              shouldRender = true;
            }

            break;

          case 6
          /* ViewLineMappingChanged */
          :
            if (this.onLineMappingChanged(e)) {
              shouldRender = true;
            }

            break;

          case 7
          /* ViewLinesChanged */
          :
            if (this.onLinesChanged(e)) {
              shouldRender = true;
            }

            break;

          case 8
          /* ViewLinesDeleted */
          :
            if (this.onLinesDeleted(e)) {
              shouldRender = true;
            }

            break;

          case 9
          /* ViewLinesInserted */
          :
            if (this.onLinesInserted(e)) {
              shouldRender = true;
            }

            break;

          case 10
          /* ViewRevealRangeRequest */
          :
            if (this.onRevealRangeRequest(e)) {
              shouldRender = true;
            }

            break;

          case 11
          /* ViewScrollChanged */
          :
            if (this.onScrollChanged(e)) {
              shouldRender = true;
            }

            break;

          case 13
          /* ViewTokensChanged */
          :
            if (this.onTokensChanged(e)) {
              shouldRender = true;
            }

            break;

          case 12
          /* ViewThemeChanged */
          :
            if (this.onThemeChanged(e)) {
              shouldRender = true;
            }

            break;

          case 14
          /* ViewTokensColorsChanged */
          :
            if (this.onTokensColorsChanged(e)) {
              shouldRender = true;
            }

            break;

          case 15
          /* ViewZonesChanged */
          :
            if (this.onZonesChanged(e)) {
              shouldRender = true;
            }

            break;

          default:
            console.info('View received unknown event: ');
            console.info(e);
        }
      }

      if (shouldRender) {
        this._shouldRender = true;
      }
    }
  }]);

  return ViewEventHandler;
}(Disposable);